import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import LlSelect from '@/components/LlSelect.vue';
import { onMounted, reactive } from 'vue';
import { useInvoiceState } from '@/modules/billing/review/editDraft/useInvoiceState';
import { useInvoiceActions } from '../useInvoiceActions';
export default {
  __name: 'AssignToFixedFeeModal',
  props: {
    checkedLineItems: Array
  },
  emits: ['cancel', 'assign'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const invoiceState = useInvoiceState();
    const invoiceActions = useInvoiceActions();
    const {
      groups
    } = invoiceState;
    const {
      findOriginalGroup
    } = invoiceActions;
    const assignToFixedFeeModalState = reactive({
      fixedFeeList: [],
      assignedFixedFee: null
    });
    const emit = __emit;
    onMounted(async () => {
      var originalGroup = findOriginalGroup(props.checkedLineItems[0]);
      let fixedFeeLineItems = [];
      const fixedFeeGroups = groups.filter(group => group.type === 'fixedFees' && group.matter.id === originalGroup.matter.id);
      if (fixedFeeGroups) {
        fixedFeeGroups.forEach(g => {
          fixedFeeLineItems = fixedFeeLineItems.concat(g.lineItems);
        });
      }
      assignToFixedFeeModalState.fixedFeeList = fixedFeeLineItems.filter(li => (li.charges ?? []).every(charge => invoiceState.isFeeAssignable(charge.id)));
    });
    const confirm = () => {
      emit('assign', {
        selectedFixedFee: assignToFixedFeeModalState.assignedFixedFee,
        checkedLineItems: props.checkedLineItems
      });
    };
    return (_ctx, _cache) => {
      const _component_v_card_title = _resolveComponent("v-card-title");
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_list_item = _resolveComponent("v-list-item");
      const _component_v_card_actions = _resolveComponent("v-card-actions");
      const _component_v_card = _resolveComponent("v-card");
      return _openBlock(), _createBlock(_component_v_card, null, {
        prepend: _withCtx(() => [_createVNode(_component_v_card_title, {
          class: "headline"
        }, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode("Assign to Fixed Fee", -1)]))]),
          _: 1
        })]),
        append: _withCtx(() => [_createVNode(_component_v_icon, {
          onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('cancel'))
        }, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode("mdi-close", -1)]))]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [_cache[5] || (_cache[5] = _createElementVNode("p", null, "Please Select the fixed fee you wish to assign to", -1)), _createVNode(LlSelect, {
            modelValue: assignToFixedFeeModalState.assignedFixedFee,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => assignToFixedFeeModalState.assignedFixedFee = $event),
            items: assignToFixedFeeModalState.fixedFeeList,
            "item-title": "description",
            "item-value": "id",
            density: "compact",
            "return-object": "",
            clearable: true,
            placeholder: "Fixed Fee",
            variant: "outlined",
            "hide-details": "true",
            label: "Fixed Fee",
            labelClass: "text-sm at-choose-client remove-outline",
            isAutocomplete: "",
            "data-cy": "fixed-fee-select"
          }, null, 8, ["modelValue", "items"])]),
          _: 1
        }), _createVNode(_component_v_card_actions, null, {
          default: _withCtx(() => [_createVNode(_component_v_list_item, {
            class: "w-100"
          }, {
            prepend: _withCtx(() => [_createVNode(LlSecondaryButton, {
              class: "mr-2",
              onBtnClick: _cache[2] || (_cache[2] = $event => _ctx.$emit('cancel'))
            }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode(" Cancel ", -1)]))]),
              _: 1
            })]),
            append: _withCtx(() => [_createVNode(LlSecondaryButton, {
              color: "primary",
              variant: "flat",
              onBtnClick: confirm,
              "data-cy": "apply-to-fixed-fee"
            }, {
              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode(" Apply ", -1)]))]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      });
    };
  }
};